import { DxfViewer } from 'dxf-viewer';

export default DxfViewer.SetupWorker();
